import {GuideStep} from '@blesk-frontend/api';
import {getPrivateAxios} from '../../libs';

export const fetchGuideStepUpdate = async (guideId: string, step: GuideStep) => {
  return getPrivateAxios()
    .patch<void>(`/guides/${guideId}/steps/${step.id}`, step)
    .then((r) => r.data);
};
